exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".summary-card[data-v-7e6fa014]{display:flex;align-items:center;padding:20px;background:#fff;border-radius:8px;box-shadow:0 2px 4px rgba(0,0,0,.1);transition:transform .2s}.summary-card[data-v-7e6fa014]:hover{transform:translateY(-2px);box-shadow:0 4px 8px rgba(0,0,0,.15)}.card-icon[data-v-7e6fa014]{width:60px;height:60px;border-radius:50%;display:flex;align-items:center;justify-content:center;margin-right:15px;font-size:24px;color:#fff}.card-content h4[data-v-7e6fa014]{margin:0;font-size:28px;font-weight:600;color:#2c3e50}.card-content p[data-v-7e6fa014]{margin:5px 0 0;font-size:14px;color:#7f8c8d}@media (max-width:768px){.summary-card[data-v-7e6fa014]{margin-bottom:15px}.card-icon[data-v-7e6fa014]{width:50px;height:50px;font-size:20px;margin-right:15px}.card-content h4[data-v-7e6fa014]{font-size:24px}.card-content p[data-v-7e6fa014]{font-size:12px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e6fa014","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/salesPersonDashboard/SummaryCards.vue
// module id = 1725
// module chunks = 0